import { z } from 'zod';

export const postpone = (annotationId: number) => {
  return {
    endpoint: `/annotations/${annotationId}/postpone`,
    method: 'POST',
    responseSchema: z.unknown(),
  } as const;
};
